import script from "./NationalityInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NationalityInput.vue?vue&type=script&setup=true&lang=js"

import "./NationalityInput.vue?vue&type=style&index=0&id=179d1298&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179d1298"]])

export default __exports__